module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8dMeeQ/tc-custom/scover.jpg",
      "alt": "This image is the cover for the book The Death-Defying 'Devil: Our Home Collection"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Death-Defying 'Devil: Our Home Collection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Winslow House is in shambles, but people call it home. It is a place for people who have almost nothing but are trying to make a life for themselves. It is also in a bad neighborhood, and no one will stop criminals from tormenting the residents...until The Death-Defying 'Devil shows up! But when the 'Devil tries to step in and protect the innocent, things take a turn for the worse and he finds himself trapped inside the house, being taken care of by the same people he was trying to save. Gail Simone (Birds of Prey, Wonder Woman) and Walter Geovani (Red Sonja, Clean Room) present the story of The Death-Defying 'Devil and a group of neighbors who will do what it takes to keep their home, and each other, safe! Includes issues #1-5 of The Death Defying 'Devil (2019).")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gail Simone\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dynamite Entertainment\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf309572","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0